import React from 'react';
import './FooterMain.scss';
import { history } from '../../_helpers/history';

const FooterMain = () => {
    const policyTextClick = (url) => {
        history.navigate(url);
    };

    return (
        <div className="footer">
            <div className="footer-container">
                <div className="footer__title__company-name">
                    <span className="img-area">
                        <img alt=""/>
                    </span>
                </div>

                <ul className="footer__term">
                    <li>
                        <span onClick={() => policyTextClick("/policy/personalInfo")} className="underline">
                            개인정보처리방침
                        </span>
                    </li>
                    <li>
                        <span onClick={() => policyTextClick("/policy/integrationService")} className="underline">
                            이용약관
                        </span>
                    </li>
                    <li>
                        <span onClick={() => policyTextClick("/policy/helloOperation")} className="underline">
                            운영정책
                        </span>
                    </li>
                </ul>

                <div className="footer__information">
                    <div className="footer-contents">
                        <span>
                            사업자명 : (주)살루스케어 ㅣ 대표 : 황현정
                        </span><br className="mo" />
                        <span className="mo-no-line">
                            사업자 등록번호 : 673-81-01878
                        </span><br className="tablet" />
                        <span className="tb-no-line">
                            통신판매업 신고 번호 : 2023-서울종로-0745
                        </span><br className="pc" />
                        <span className="pc-no-line">
                            전화 : 02-6324-8000
                        </span><br className="tablet" />
                        <span className="tb-no-line">
                            주소 : (우)04513 서울시 중구 서소문동 120-23번지 부영빌딩 11층
                        </span><br className="tablet" />
                        <span className="tb-no-line">
                            의료기기 판매업 신고번호 : 제 2023-3000034-00010 호
                        </span>
                    </div>
                    <div className="copyright">
                        <span>Copyright 2025.Saluscare Corp. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FooterMain;
